export default "{{render_context}} .pdc-widget-gantt .theme-margin-left {\r\n  background-color: <%= theme['widget-gantt-left-margin-backcolor'] %>;\r\n}";